import React from 'react';
import { Link } from 'react-router-dom';
import { staticImageAssets } from 'js/constants/Paths';

// import components
import NavigationGrid from 'js/components/navigation/Navigation.grid';
// import GenericSvgLogo from 'js/components/generic/Ganeric.svg-logo';

const SectionHeader = () => {
  return (
    <header className="section-header">
      <div className="">
        <div className="section-header__logo">
          <Link to="/" aria-label="Go to homepage">
            <img
              src={staticImageAssets('images/static/logo.png')}
              alt="Stan & Gran"
              title="Stan & Gran"
              width="117"
              height="116"
            />
          </Link>
        </div>
        <NavigationGrid />
      </div>
    </header>
  );
};

export default SectionHeader;
